import { AxiosError } from 'axios';
import request from 'common/request';
import { useQuery } from 'react-query';

export const useGetSubscribeDetail = ( options?: any) => {
  return useQuery<any, AxiosError>(
    'subscribeDetailData',
    async () => {
      try {
        const response = await request.get(`/user/subscribe/detail`,
        );
        
        return response.data;
      } catch (e) {
        //@ts-ignore
        const result = e.response
        return result
      }
    },
    {
      ...options,
    }
  );
};

export default useGetSubscribeDetail;
